import { ChangeEventHandler, FC, useEffect, useState } from 'react';

import { setLocalStorage } from '../../../common/util/localStorage';
import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';
import CheckoutAddressField from '../../TextField/CheckoutAddressField/CheckoutAddressField';

interface IAddressValue {
  other_recipient_phone: string;
  other_recipient_name: string;
  delivery_courier_comment: string;
  delivery_address: string;
}

//Модльные окна "Куда доставить заказ"
export const Address: FC = () => {
  const { setAddAddressValue } = useActions();
  const { addressValue } = useBasket();

  const onAddAddressData = (name: string, value: any) => {
    const oldValue = {
      ...addressValue,
      [name]: value,
    };
    //Сохраняем состояние в LocalStorage
    setLocalStorage.saveToLocalStorage('addAddressUser', oldValue);
    setAddAddressValue(oldValue);
  };
  //Добавить комментарий пользователя
  const onAddCommentValue = (value: any) => {
    onAddAddressData('comment', value);
  };
  //Добавить ФИО пользователя
  const onAddFullName = (value: any) => {
    onAddAddressData('fullName', value);
  };
  //Добавить телефон получателя пользователя
  const onAddUserPhone = (value: any) => {
    onAddAddressData('phone', value);
  };

  //Добавить адрес пользователя
  const onAddAddressDelivery = (value: any) => {
    onAddAddressData('address', value);
  };

  return (
    <div className="add-address-modal">
      <div className="add-address-modal_group1">
        <CheckoutAddressField
          onChange={onAddAddressDelivery}
          value={addressValue.address}
          className="input__inp"
          label="Укажите адрес доставки"
        />
      </div>
      <div className="add-address-modal_group2">
        <div className="add-address-modal_group2_wrapper">
          <CheckoutAddressField
            onChange={onAddFullName}
            value={addressValue.fullName}
            className="input__inp"
            label="ФИО получателя"
          />
          <CheckoutAddressField
            onChange={onAddUserPhone}
            value={addressValue.phone}
            className="add-address-modal_group2_inp"
            label="Телефон получателя"
          />
        </div>
      </div>

      <div className="add-address-modal_group3">
        <CheckoutAddressField
          onChange={onAddCommentValue}
          value={addressValue.comment}
          className="add-address-modal_group3_inp"
          label="Комментарий курьеру"
        />
      </div>
    </div>
  );
};
